export const cardPage = {
    "cvv": "CVV",
    "expiry": "Caducidad",
    "card_number": "Número de tarjeta",
    "future_charge": "Tu primer cargo será el {{date}}",
    "total_payable": "Total a pagar",
    "payment_provider_error": "Error interno del proveedor de pago",
    "payment_error": "Error de pago, intente nuevamente",
};
